import { Avatar } from '@/components/ui/custom/dataDisplay/Avatar';
import { Tooltip } from '@/components/ui/custom/dataDisplay/Tooltip';
import User from '@/models/User';
import { ClassNameComponent } from '@/utils/ClassNameComponent';
import { twMerge } from 'tailwind-merge';
import useOwnerName from './Owners.hook';

type OwnersProps = {
  owners: User[];
  className?: Pick<ClassNameComponent, 'ul'>;
};
export default function Owners({ owners, className }: OwnersProps) {
  return (
    <ul className={twMerge('flex gap-1 flex-wrap justify-end', className?.ul)}>
      {owners.map(user => (
        <Owner user={user} key={user.id} />
      ))}
    </ul>
  );
}

type OwnerProps = {
  user: User;
};

export const Owner = ({ user }: OwnerProps) => {
  const fullname = useOwnerName(user);
  return (
    <Tooltip
      text={fullname}
      classNameContainer="overflow-x-hidden"
      color="accent"
      key={user.id}
    >
      <Avatar
        className="gap-1 text-base-content text-14 text-right overflow-x-hidden"
        userId={user.id}
      />
    </Tooltip>
  );
};
